import React from "react";
import { Carousel } from "react-bootstrap";
import "./RoadRiderz.css";
const RoadRiderz = () => {
  return (
    <div className="roadRiderzProject">
      <h1 className="projects-Header">RoadRiderz Custom X</h1>
      <div className="row site-details-rrz">
        <div className="col-md-6 p-3">
          <p>
            * This is Customize motor bike related website, user can buy &
            remove product also implement Stripe payment Gateway system
            (Stripe).
          </p>
          <p>
            * Using technologies are ReactJS, NodeJS, ExpressJS, MongoDB,
            Firebase, Heroku.
          </p>
          <p>
            * A fully functional full-stack web app basses on MERN stack. It has
            admin panel.
          </p>
          <p>* This Site fully responsive for large and small device.</p>
          <p>
            * This Site has Authentication system like google signin, register
            for new user with firebase.
          </p>
          <p>* Also implement Authorization system </p>
        </div>
        <div className="col-md-6 p-3">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/kgTVJTk/rrz1.png"
                alt="First slide"
              />
              <Carousel.Caption>
                {/* <h3>First slide label</h3>
                <p>
                  Nulla vitae elit libero, a pharetra augue mollis interdum.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/PNWtqQ4/rrz2.png"
                alt="Second slide"
              />

              <Carousel.Caption>
                {/* <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/SPzkyCQ/rrz3.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Third slide label</h3>
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl
                  consectetur.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src="https://i.ibb.co/sCrskHC/rrz4.png"
                alt="Third slide"
              />

              <Carousel.Caption>
                {/* <h3>Fourth slide label</h3>
                <p>
                  Praesent commodo cursus magna, vel scelerisque nisl
                  consectetur.
                </p> */}
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
     <div className="siteInfo">
     <h3 className="seeLive">See Live: </h3>
      <span >
        {" "}
        <a className="liveSite" target="_blank" href="https://road-riderz-custom-express.web.app/"><b>LiveSite</b></a>
      </span>
      <span >
        <a className="clientSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/RoadRiderz-CustomX-MERN-Stack/tree/main/road-riderz-custom-express"><b>ClientSideCode</b></a>
      </span>
      <span>
        <a className="serverSide" target="_blank" href="https://github.com/Iasir-Arafat-riaz/RoadRiderz-CustomX-NodeExpressServer-Heroku"><b>ServerSideCode</b></a>
      </span>
     </div>
    </div>
  );
};

export default RoadRiderz;
